import __ from 'localisation';

export const ROUTE_USER_SETTINGS = {
  id: 'user-settings',
  title: __('menu_settings'),
  route: '/dashboard/settings',
  icon: 'Cog',
};

// const ROUTE_HOME = {
//   title: __('menu_home'),
//   route: '/dashboard',
//   iconName: 'house',
// };

export const ROUTE_CLIENTS = {
  id: 'clients',
  title: __('menu_clients'),
  route: '/dashboard/clients',
  icon: 'newspaper fold',
};

export const ROUTE_PORTFOLIOS = {
  id: 'portfolios',
  title: __('menu_portfolios'),
  route: '/dashboard/clients',
  icon: 'newspaper fold',
};

export const ROUTE_USERS = {
  id: 'users',
  title: __('menu_users'),
  route: '/dashboard/profiles',
  icon: 'user',
};

export const ROUTE_APPROVALS = {
  id: 'approvals',
  title: __('menu_approvals'),
  route: '/dashboard/approvals',
  icon: 'Notes Checklist Flip',
};

export const ROUTE_APPROVALS_HUBINS_BACKOFFICE = {
  id: 'approvals-hubins-backoffice',
  title: 'Hubins Backoffice',
  route: '/dashboard/approvals/hubins-backoffice',
  icon: 'Common File Text by Streamlinehq',
};

export const ROUTE_APPROVALS_HUBINS_COMPLIANCE = {
  id: 'approvals-hubins-compliance',
  title: 'Hubins Compliance',
  route: '/dashboard/approvals/hubins-compliance',
  icon: 'Common File Text by Streamlinehq',
};

export const ROUTE_APPROVALS_QUANTUM_LEBEN_BACKOFFICE = {
  id: 'approvals-quantum-leben-backoffice',
  title: 'Quantum Backoffice',
  route: '/dashboard/approvals/quantum-leben-backoffice',
  icon: 'Common File Text by Streamlinehq',
};

export const ROUTE_APPROVALS_QUANTUM_LEBEN_COMPLIANCE = {
  id: 'approvals-quantum-leben-compliance',
  title: 'Quantum Compliance',
  route: '/dashboard/approvals/quantum-leben-compliance',
  icon: 'Common File Text by Streamlinehq',
};

export const ROUTE_APPROVALS_FILTER = {
  id: 'approvals-filter',
  title: 'Filter',
  route: '/dashboard/approvals/filter',
  icon: 'Common File Text by Streamlinehq',
};

export const ROUTE_APPROVALS_ARCHIVED = {
  id: 'approvals-archived',
  title: __('archived_approvals'),
  route: '/dashboard/approvals/archived',
  icon: 'Common File Text by Streamlinehq',
};

export const ROUTE_APPROVALS_COMPLETED = {
  id: 'approvals-completed',
  title: __('completed_approvals'),
  route: '/dashboard/approvals/completed',
  icon: 'Common File Text by Streamlinehq',
};

export const ROUTE_ORDERS_ALL_ORDERS = {
  id: 'orders-all-orders',
  title: __('all_orders'),
  route: '/dashboard/orders/transactions',
  icon: 'Common File Text by Streamlinehq',
};

export const ROUTE_ORDERS_FA_TRANSACTIONS = {
  id: 'orders-fa-transactions',
  title: __('fa_transactions'),
  route: '/dashboard/orders/fa-transactions',
  icon: 'Common File Text by Streamlinehq',
};

export const ROUTE_ORDERS_CREATE_TOF = {
  id: 'orders-create-tof',
  title: __('create_premium_in_kind'),
  route: '/dashboard/orders/create-tof',
  icon: 'Common File Text by Streamlinehq',
};

export const ROUTE_ORDERS = {
  id: 'orders',
  title: __('Orders'),
  route: '/dashboard/orders',
  icon: 'Common File Text by Streamlinehq',
  subItems: [ROUTE_ORDERS_ALL_ORDERS, ROUTE_ORDERS_FA_TRANSACTIONS, ROUTE_ORDERS_CREATE_TOF],
};

export const ROUTE_SECURITIES_CMS = {
  id: 'securities-cms',
  title: __('menu_securities_cms'),
  route: `/dashboard/cms`,
  icon: 'Common File Text by Streamlinehq',
};

export const ROUTE_FORMS = {
  id: 'forms',
  title: __('menu_forms'),
  route: `/formscms`,
  icon: 'Common File Text by Streamlinehq',
  external: true,
};

export const ROUTE_FILES = {
  id: 'files',
  title: __('menu_files'),
  route: `/dashboard/files`,
  icon: 'Common File Text by Streamlinehq',
};

export const ROUTE_RISK_ASSESSMENT_PARAMS = {
  id: 'risk-assessment-params',
  title: __('menu_risk_assessment_params'),
  route: '/dashboard/risk-assessment-params',
  icon: 'Common File Text by Streamlinehq',
};

export const ROUTE_REPORT_GENERATOR = {
  id: 'report-generator',
  title: __('report_generator'),
  route: '/dashboard/report-generator',
  icon: 'Common File Text by Streamlinehq',
};

export const ROUTE_PLATFORM_ALERTS = {
  id: 'platform-alerts',
  title: __('menu_platform_alerts'),
  route: '/dashboard/alerts',
  icon: 'Common File Text by Streamlinehq',
};

export const ROUTE_USER_ROLE_MANAGEMENT = {
  id: 'user-role-management',
  title: 'User role management',
  route: '/db/users',
  icon: 'Common File Text by Streamlinehq',
};

// const ROUTE_PENDING_FA_TRANSACTIONS = {
//   id: 'pending-fa-transactions',
//   title: __('menu_pending_fa_transactions'),
//   route: '/dashboard/pending-fa-transactions',
//   iconName: 'Common File Text by Streamlinehq',
//   icon: <Icon icon="Common File Text by Streamlinehq" />,
// }

export const getAvailableRoutes = (userRoles) => {
  if (!userRoles || userRoles.length < 1) {
    return [];
  }

  const routes = [];

  const isBackofficeRole = [
    'hubins_backoffice',
    'hubins_compliance',
    'quantum_backoffice',
    'quantum_compliance',
  ].some((role) => userRoles.includes(role));

  const canView = (rolesThatCanViewThos) => {
    return userRoles.some((role) => rolesThatCanViewThos.includes(role));
  };

  const canViewHubinsBackoffice = canView(['hubins_backoffice', 'hubins_compliance']);
  const canViewHubinsCompliance = canView(['hubins_backoffice', 'hubins_compliance']);
  const canViewQuantumBackoffice = canView([
    'hubins_backoffice',
    'hubins_compliance',
    'quantum_backoffice',
    'quantum_compliance',
  ]);
  const canViewQuantumCompliance = canView([
    'hubins_backoffice',
    'hubins_compliance',
    'quantum_backoffice',
    'quantum_compliance',
  ]);
  const canViewFilter = canView(['hubins_backoffice', 'hubins_compliance']);

  // Root
  if (isBackofficeRole) {
    // routes.push(ROUTE_HOME);
    // routes.push(ROUTE_PORTFOLIOS);
    routes.push(ROUTE_CLIENTS);
    routes.push(ROUTE_USERS);

    // Approvals + sub items
    const approvalsSubRoutes = [];
    if (canViewHubinsBackoffice) approvalsSubRoutes.push(ROUTE_APPROVALS_HUBINS_BACKOFFICE);
    if (canViewHubinsCompliance) approvalsSubRoutes.push(ROUTE_APPROVALS_HUBINS_COMPLIANCE);
    if (canViewQuantumBackoffice) approvalsSubRoutes.push(ROUTE_APPROVALS_QUANTUM_LEBEN_BACKOFFICE);
    if (canViewQuantumCompliance) approvalsSubRoutes.push(ROUTE_APPROVALS_QUANTUM_LEBEN_COMPLIANCE);
    if (canViewFilter) approvalsSubRoutes.push(ROUTE_APPROVALS_FILTER);
    approvalsSubRoutes.push(ROUTE_APPROVALS_ARCHIVED);
    approvalsSubRoutes.push(ROUTE_APPROVALS_COMPLETED);

    routes.push({
      ...ROUTE_APPROVALS,
      subItems: approvalsSubRoutes,
    });

    routes.push(ROUTE_ORDERS);
  }

  if (userRoles.includes('broker')) {
    routes.push({
      ...ROUTE_PORTFOLIOS,
      title: __('menu_my_clients'),
    });
  }

  // Admin
  if (
    userRoles.includes('admin') ||
    userRoles.includes('hubins_backoffice') ||
    userRoles.includes('hubins_compliance')
  ) {
    const adminSubRoutes = [];

    if (userRoles.includes('admin')) {
      adminSubRoutes.push(ROUTE_FORMS);
      adminSubRoutes.push(ROUTE_FILES);
      adminSubRoutes.push(ROUTE_RISK_ASSESSMENT_PARAMS);
      adminSubRoutes.push(ROUTE_REPORT_GENERATOR);
      adminSubRoutes.push(ROUTE_PLATFORM_ALERTS);
      adminSubRoutes.push(ROUTE_USER_ROLE_MANAGEMENT);
    }

    if (userRoles.includes('hubins_backoffice') || userRoles.includes('hubins_compliance')) {
      adminSubRoutes.push(ROUTE_SECURITIES_CMS);
    }

    // Add admin group and its subroutes
    routes.push({
      id: 'admin',
      title: __('menu_admin'),
      route: ROUTE_FORMS.route,
      icon: 'pencil write 2',
      subItems: adminSubRoutes,
    });
  }

  // General
  routes.push(ROUTE_USER_SETTINGS);

  return routes;
};

export default getAvailableRoutes;
